/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactSiteResponseData,
  GetContactSiteResponseDataFromJSON,
  GetContactSiteResponseDataFromJSONTyped,
  GetContactSiteResponseDataToJSON
} from './GetContactSiteResponseData'

/**
 *
 * @export
 * @interface GetContactShareSiteResponse
 */
export interface GetContactShareSiteResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactShareSiteResponse
   */
  status?: number
  /**
   *
   * @type {GetContactSiteResponseData}
   * @memberof GetContactShareSiteResponse
   */
  data?: GetContactSiteResponseData
}

export function GetContactShareSiteResponseFromJSON(json: any): GetContactShareSiteResponse {
  return GetContactShareSiteResponseFromJSONTyped(json, false)
}

export function GetContactShareSiteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactShareSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactSiteResponseDataFromJSON(json['data'])
  }
}

export function GetContactShareSiteResponseToJSON(value?: GetContactShareSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactSiteResponseDataToJSON(value.data)
  }
}
